import { z } from 'zod';
/**
 * The domain enums from plan §4, shared by every area's schemas. They are persisted as `varchar` +
 * `$type<>()` (never pg enums), so the service-side unions in `src/app/domain` mirror these exactly (a service spec
 * checks the board metric keys against `domain/board-metric-keys.ts`).
 */
export const userRoleSchema = z.enum(['ADMIN', 'PM', 'OWNER', 'MANAGER']);
export const userStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const pillarAccessSchema = z.enum(['VIEW', 'EDIT']);
export const pillarSchema = z.enum(['GET', 'SELL', 'SERVICE', 'PARTS', 'FINANCE']);
export const divisionSchema = z.enum(['PP', 'LOG', 'MRK', 'SAL', 'CX', 'SER', 'SP', 'FA']);
export const unitSchema = z.enum(['NUMBER', 'PERCENTAGE', 'CURRENCY', 'DAYS', 'HOURS', 'RATIO', 'DECIMAL', 'TEXT']);
export const currencySchema = z.enum(['JOD', 'USD', 'EUR', 'CNY', 'JPY']);
export const valueTypeSchema = z.enum(['ABSOLUTE', 'CUMULATIVE']);
export const kpiSourceSchema = z.enum(['MANUAL', 'CALCULATED']);
export const kpiStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const targetDirectionSchema = z.enum(['AT_LEAST', 'AT_MOST']);
export const targetPeriodSchema = z.enum(['ANNUAL', 'CUSTOM']);
export const targetStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const ageSchema = z.enum(['BRONZE', 'SILVER', 'GOLDEN']);
/** The closed list of board metric keys (plan §8.1), in the order the bindings page lists them. */
export const BOARD_METRIC_KEY_VALUES = [
    'PIPE_ORDERED',
    'PIPE_PRODUCED',
    'PIPE_SHIPPED',
    'PIPE_RECEIVED',
    'PIPE_IN_STOCK',
    'PIPE_IN_PREP',
    'PIPE_STOCK_AGE_DAYS',
    'PIPE_LEAD_TIME_DAYS',
    'FUNNEL_LEADS',
    'FUNNEL_CONTACTED',
    'FUNNEL_VISITS',
    'FUNNEL_TEST_DRIVES',
    'FUNNEL_QUOTES',
    'FUNNEL_SOLD',
    'FUNNEL_INVOICED',
    'FUNNEL_DELIVERED',
    'VOLUME_DELIVERED',
    'VEHICLE_REVENUE',
    'AFTERSALES_REVENUE',
    'PARTS_REVENUE',
    'GROSS_PROFIT',
    'OPEX',
    'CASH_FLOW',
    'COLLECTIONS',
    'GROSS_MARGIN',
    'RECEIVABLES',
    'PAYABLES',
    'INVENTORY_VALUE',
    'SVC_BOOKINGS',
    'SVC_SERVICED',
    'SVC_WARRANTY_JOBS',
    'SVC_REPEAT_REPAIRS',
    'SVC_LABOUR_REVENUE',
    'SVC_UTILISATION',
    'SVC_TURNAROUND_HOURS',
    'SVC_FIRST_TIME_FIX',
    'SVC_CSAT',
    'PARTS_SALES',
    'PARTS_GROSS_PROFIT',
    'PARTS_EMERGENCY_ORDERS',
    'PARTS_DELAYED_JOBS',
    'PARTS_AVAILABILITY',
    'PARTS_FILL_RATE',
    'PARTS_BACKORDERS',
    'PARTS_INVENTORY_VALUE',
    'PARTS_OBSOLETE_VALUE',
];
export const boardMetricKeySchema = z.enum(BOARD_METRIC_KEY_VALUES);
/**
 * The static product codes (plan §3.3, Phase 8): one per model card on the Products page, in the page's order. The
 * service pins `domain/product-metrics.ts` to this list and the web's product constants carry one each.
 */
export const PRODUCT_CODE_VALUES = [
    'QQ3-EV',
    'ARRIZO-5',
    'TIGGO-X7',
    'ARRIZO-8',
    'TIGGO-4-HEV',
    'TIGGO-X4',
    'TIGGO-V',
    'TIGGO-8',
    'HIMLA',
    'TIGGO-7-PHEV',
    'TIGGO-X9',
    'TIGGO-9',
];
export const productCodeSchema = z.enum(PRODUCT_CODE_VALUES);
/** The per-model figures a product card shows (user decision 2026-10-11: sold and delivered only). */
export const PRODUCT_METRIC_VALUES = ['SOLD', 'DELIVERED'];
export const productMetricSchema = z.enum(PRODUCT_METRIC_VALUES);
//# sourceMappingURL=enum.schemas.js.map